import styled from 'styled-components';

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Document = styled.p`
  font-size: 0.75rem;
`;
